import { BranchDetails } from "@/@types/Branches";
import { ApiClient } from "../../ApiClient";
import { GetBranchDetailsResponse } from "../schema/GetBranchDetailsResponse";
import { mapBranchDetails } from "../../mappers/branches/branchDetailsMapper";

export const getBranchDetails = async (typeSlug: string, branchSlug: string): Promise<BranchDetails> => {
    const client = ApiClient.getInstance()

    const response = await client.get<GetBranchDetailsResponse>(`branches/office/${typeSlug}/${branchSlug}`)

    const mappedResponse = mapBranchDetails(response.data)

    return mappedResponse;
}